import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getServiceProductDetail } from '@/api/Services';
import StepLineBar from './StepLineBar';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';

// 定义API返回的图片数据结构
interface ProductMainImage {
  product_id: string;
  product_media_type: string;
  product_media_file_url: string;
  file_id: number;
  product_media_id: number;
}

const stepTitles = ['Basic Information', 'Sales Information', 'Graphic Description'];

const ServiceCategory: React.FC = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [searchParams] = useSearchParams();
  
  const [formData, setFormData] = useState<any>({
    product_id: '', // 添加产品ID字段
    step1: {
      category: 0,
      mainImages: [],
      title: '',
      desc: '',
      customAttrs: []
    },
    step2: {
      attributes: [],
      specs: [],
      reservationOpen: false,
      reservationTimes: []
    },
    step3: {
      product_content: []
    }
  });

  const handleNext = (data: any) => {
    // 确保产品ID在步骤之间传递
    const updatedData = { ...data };
    if (data.product_id) {
      setFormData((prev: any) => ({ ...prev, product_id: data.product_id, [`step${currentStep}`]: data }));
    } else {
      setFormData((prev: any) => ({ ...prev, [`step${currentStep}`]: data }));
    }
    if (currentStep < 3) setCurrentStep(currentStep + 1);
  };
  const handlePrev = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };
  // 获取产品数据编辑
  const fetchProductData = async (productId: string) => {
    try {
      
      const response = await getServiceProductDetail({ service_product_id: productId });
      
      if (response.message === "Success" && response.data) {
        const data = response.data;
        console.log('获取到的产品详情数据:', data);
        // 将API返回的数据映射到表单结构上
        const mappedData = {
          product_id: productId,
          step1: {
            category: data.product_category_id || 0,
            mainImages: (data.product_main_images || []).map((img: ProductMainImage) => ({
              uid: img.product_media_id?.toString() || Math.random().toString(),
              name: `image_${img.product_media_id || Math.random()}.jpg`,
              status: 'done',
              url: img.product_media_file_url,
              product_id: img.product_id,
              product_media_type: img.product_media_type,
              product_media_video_cover_id: null,
              file_id: img.file_id,
              product_media_id: img.product_media_id
            })),
            title: data.service_name || '',
            desc: data.service_description || '',
            customAttrs: data.custom_attributes || []
          },
          step2: {
            attributes: data.sales_attributes || [],
            specs: data.sales_specifications || [],
            reservationOpen: data.reservation_service_enabled || false,
            reservationTimes: data.reservation_time_slots || []
          },
          step3: {
            product_content: data.service_detail_contents || [],
            video_attachments: data.service_video_attachments || []
          }
        };
        setFormData(mappedData);
      } else {
        // console.error('获取产品详情失败:', response.message);
      }
    } catch (error) {

    }
  };

  // 监听 URL 参数变化，获取产品数据
  useEffect(() => {
    const productId = searchParams.get('id');
    if (productId) {
      fetchProductData(productId);
    } else {
      // 新建模式，重置表单数据
      setFormData({
        product_id: '',
        step1: { category: 0, mainImages: [], title: '', desc: '', customAttrs: [] },
        step2: { attributes: [], specs: [], reservationOpen: false, reservationTimes: [] },
        step3: { product_content: [] }
      });
    }
  }, [searchParams]);

  const handleSubmit = (data: any) => {
    const allData = { ...formData, step3: data };
    
    // 这里可以调用API保存或更新服务
    // 如果有 product_id，说明是编辑模式
    // 如果没有 product_id，说明是新建模式
  };

  return (
    <div style={{ background: '#fff', minHeight: '100vh', width: '100%', padding: '0 24px' }}>
      <h1 style={{ color: '#13b26b', fontWeight: 700, fontSize: 36, marginBottom: 24 }}>Service Category</h1>
      <StepLineBar currentStep={currentStep} stepData={stepTitles} />
        <>
          {currentStep === 1 && (
            <Step1 
              onNext={handleNext} 
              defaultValue={{ ...formData.step1, product_id: formData.product_id }} 
            />
          )}
          {currentStep === 2 && (
            <Step2 
              onNext={handleNext} 
              onPrev={handlePrev} 
              defaultValue={{ ...formData.step2, product_id: formData.product_id }} 
            />
          )}
          {currentStep === 3 && (
            <Step3 
              onNext={handleSubmit} 
              onPrev={handlePrev} 
              formData={formData} 
            />
          )}
        </>

    </div>
  );
};

export default ServiceCategory; 